import { Link } from 'react-router-dom';
import { ArrowLeft, LucideIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface ToolPageProps {
  title: string;
  description: string;
  icon: LucideIcon;
  children: React.ReactNode;
}

export default function ToolPage({ title, description, icon: Icon, children }: ToolPageProps) {
  return (
    <div className="space-y-8">
      <div>
        <Button
          variant="ghost"
          size="sm"
          asChild
          className="mb-6 -ml-2 text-slate-600 hover:text-slate-900 hover:bg-slate-100"
        >
          <Link to="/tools" className="inline-flex items-center transition-colors">
            <ArrowLeft className="w-4 h-4 mr-2" />
            Back to Tools
          </Link>
        </Button>
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-3xl font-semibold text-slate-900 mb-2">{title}</h1>
            <p className="text-slate-600">{description}</p>
          </div>
          <div className="w-12 h-12 rounded-xl bg-brand-900 flex items-center justify-center shrink-0">
            <Icon className="w-6 h-6 text-white" />
          </div>
        </div>
      </div>
      {children}
    </div>
  );
}
